import * as MailConnection from 'connections/mail';
import * as MailTransform from 'transforms/mail';

export const save = async mailToSave => {
  const { mail } = MailTransform.toFirestore(mailToSave);
  await MailConnection.save(mail);
};
